import React from 'react';

import {
  Box,
  Divider,
  List,
  ListItemIcon,
  ListItemText, Stack, Typography, useTheme,
} from '@mui/material';

import ContentCard, { ContentCardProps } from '../../../components/ContentCard';
import EventIcon from '../../../components/EventIcon';
import ListItemButtonLink from '../../../components/ListItemButtonLink';
import { NothingUpcomingText } from '../index.styles';
import { EventOption } from '../types';

interface EventsCardProps extends Omit<ContentCardProps, 'children'> {
  events: EventOption[];
}

const EventsCard = ({ events, ...props }: EventsCardProps) => {
  const theme = useTheme();
  const isMd = theme.breakpoints.up('md');

  return (
    <ContentCard variant="outlined" title="Latest Events" {...props}>
      {events.length > 0 ? (
        <List>
          {events.map((event: EventOption, i) => (
            <Stack>
              <ListItemButtonLink key={event.title} href={event.href} target={event?.openInNewTab ? '_blank' : undefined} disableRipple>
                {isMd && (
                  <ListItemIcon>
                    <EventIcon
                      color="gray"
                      date={event.date}
                      activeStartDate={event.activeStartDate}
                      activeEndDate={event.activeEndDate}
                    />
                  </ListItemIcon>
                )}
                <Stack direction="column">
                  <ListItemText
                    primary={event.title}
                    primaryTypographyProps={{ variant: 'h5' }}
                  />
                  <Typography variant="body2" color="textSecondary">{event.description}</Typography>
                </Stack>
              </ListItemButtonLink>
              {i < events.length - 1 && (
                <Box paddingTop={1} paddingBottom={1}>
                  <Divider />
                </Box>
              )}
            </Stack>
          ))}
        </List>
      ) : (
        <NothingUpcomingText variant="body2" color="textSecondary">
          No upcoming events
        </NothingUpcomingText>
      )}
    </ContentCard>

  );
};

export default EventsCard;
